"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = require("owa-mail-list-store");
/**
 * Gets contextual information for ApplyConversationAction for a given conversation
 */
function getUniqueConversationContextsForRowKey(rowKeys, tableViewId) {
    var conversationActionContexts = [];
    var rowIds = {};
    rowKeys.forEach(function (rowKey) {
        var conversationContext = owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableViewId);
        // Do not add contexts for duplicate row Ids
        if (!rowIds[conversationContext.conversationId]) {
            rowIds[conversationContext.conversationId] = true;
            conversationActionContexts.push(conversationContext);
        }
    });
    return conversationActionContexts;
}
exports.default = getUniqueConversationContextsForRowKey;
//# sourceMappingURL=getUniqueConversationContextsForRowKey.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/getUniqueConversationContextsForRowKey.js
// module id = 3815
// module chunks = 62